import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('efa_cmp_-_beta_fields_management_features');
	},
};
